module.exports = __webpack_public_path__ + "img/car.98f10866.png";